import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-manual',
  templateUrl: './icon-manual.component.html',
  styleUrls: ['./icon-manual.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconManualComponent {}
